import React, { useEffect } from 'react'

declare global {
  interface Window {
    adsbygoogle: any
  }
}

const GoogleAd = props => {
  useEffect(() => {
    setTimeout(() => {
      try {
        const adsbygoogle = window.adsbygoogle || []
        adsbygoogle.push({})
      } catch (e) {
        console.error(e)
      }
    }, 1000) // delay the ad startup, GA isn't able to detect the parent container size right after loading
  }, [props.slot, props.client])

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client={props.client}
      data-ad-slot={props.slot}
      data-ad-format="auto"
    />
  )
}

export default GoogleAd
